import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { AddinReceiverAgent } from "../addin-page-enums";

@Component({
  selector: "app-global-user-settings-wrapper",
  templateUrl: "./global-user-settings-wrapper.component.html",
  styleUrls: ["./global-user-settings-wrapper.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GlobalUserSettingsWrapperComponent implements OnInit {
  isVisibleEteModal: boolean;
  blankValue = "AsHyphen";
  isRTDDisabled = false;
  percentAbsValue = 0.01;
  excelAdvancedDefault = {
    preferred_no_data_format: "",
    is_RTD_disabled: false,
    percent_value_multiplication_factor: null,
  };
  constructor(private store: Store<AppState>) {}
  ngOnInit() {
    this.isVisibleEteModal = false;
    this.readAdvancedSettings();
    this.store
      .select(
        stateGetter(
          "globalHeader",
          "globalAppSettings",
          "addin_export_settings",
          "advanced_options",
        ),
      )
      .subscribe((data: AppState) => {
        if (!data) {
          return;
        }
        this.blankValue = data["preferred_no_data_format"];
        this.isRTDDisabled = data["is_RTD_disabled"];
        this.percentAbsValue = data["percent_value_multiplication_factor"];
        if (window["WebAppHelper"]) {
          window["WebAppHelper"].ExecuteAction(
            "VisibleAlpha.Common.CommandsHandlers.SetRegistryCommandHandler",
            JSON.stringify({
              key: "IsRTDDisabled",
              value: !data["is_RTD_disabled"],
            }),
          );
          window["WebAppHelper"].ExecuteAction(
            "VisibleAlpha.Common.CommandsHandlers.SetRegistryCommandHandler",
            JSON.stringify({
              key: "PreferredNoDataFormat",
              value: data["preferred_no_data_format"],
            }),
          );
          window["WebAppHelper"].ExecuteAction(
            "VisibleAlpha.Common.CommandsHandlers.SetRegistryCommandHandler",
            JSON.stringify({
              key: "PercentValueMultiplicationFactor",
              value: data["percent_value_multiplication_factor"],
            }),
          );
        }
      });
  }
  readAdvancedSettings() {
    if (!window["WebAppHelper"]) {
      this.excelAdvancedDefault = {
        preferred_no_data_format: this.blankValue,
        is_RTD_disabled: this.isRTDDisabled,
        percent_value_multiplication_factor: this.percentAbsValue ? 1 : 0.01,
      };
      setTimeout(() => {
        this.isVisibleEteModal = true;
      }, 10);
      return;
    }
    this.isRTDDisabled =
      window["WebAppHelper"].ExecuteAction(
        "VisibleAlpha.Common.CommandsHandlers.GetRegistryCommandHandler",
        "IsRTDDisabled",
      ) === "True"
        ? false
        : true;
    this.blankValue =
      window["WebAppHelper"].ExecuteAction(
        "VisibleAlpha.Common.CommandsHandlers.GetRegistryCommandHandler",
        "PreferredNoDataFormat",
      ) || "AsHyphen";
    this.percentAbsValue = window["WebAppHelper"].ExecuteAction(
      "VisibleAlpha.Common.CommandsHandlers.GetRegistryCommandHandler",
      "PercentValueMultiplicationFactor",
    );
    this.percentAbsValue = Number(this.percentAbsValue);
    this.excelAdvancedDefault = {
      preferred_no_data_format: this.blankValue,
      is_RTD_disabled: this.isRTDDisabled,
      percent_value_multiplication_factor: this.percentAbsValue,
    };
    setTimeout(() => {
      this.isVisibleEteModal = true;
    }, 10);
  }
  onCloseEteModal() {
    this.isVisibleEteModal = false;
    this.closeBrowserInstance();
  }
  closeBrowserInstance(): void {
    if (window["WebAppHelper"] && window["WebAppHelper"].ExecuteAction) {
      window["WebAppHelper"].ExecuteAction(AddinReceiverAgent.CloseWizard, "");
    }
  }
}
